module.exports = {
      id: "cherry-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#cherry",
      toString: function () {
        return this.url;
      }
    }